<template>
  <div class="dp-page-section">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "DpPageSection"
  };
</script>

<style>
  .dp-page-section {
    margin-bottom: 2rem;
  }
</style>
